import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Box} from "../../modelo/producto/box";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BoxService {

  constructor(private readonly http: HttpClient) { }


  nuevoBox(box:Box):Observable<any>{
    const params = new HttpParams().set('funcion', 'nuevoBox').set('box',JSON.stringify(box));
    return this.http.get(`${environment.url.gestionBox}`, { params });
  }
  modificarBox(box:Box):Observable<any>{
    const params = new HttpParams().set('funcion', 'modificarBox').set('box',JSON.stringify(box));
    return this.http.get(`${environment.url.gestionBox}`, { params });
  }

  eliminarBox(bId:number):Observable<any>{
    const params = new HttpParams().set('funcion', 'eliminarBox').set('bId',''+bId);
    return this.http.get(`${environment.url.gestionBox}`, { params });
  }

  traerBox(bId:number):Observable<any>{
    const params = new HttpParams().set('funcion', 'traerBox').set('bId',''+bId);
    return this.http.get(`${environment.url.gestionBox}`, { params });
  }

  listarBox():Observable<any>{
    const params = new HttpParams().set('funcion', 'listarBox');
    return this.http.get(`${environment.url.gestionBox}`, { params });
  }

}
